import { cn } from '@/lib/cn';
import { ArrowDown, ArrowUp, Minus, type LucideIcon } from 'lucide-react';

type KpiCardProps = {
  label: string;
  value: string | number;
  variation?: number;
  unit?: string;
  Icon?: LucideIcon;
  state?: 'default' | 'success' | 'warn' | 'danger';
  helper?: string;
};

export function KpiCard({ label, value, variation, unit, Icon, state = 'default', helper }: KpiCardProps) {
  return (
    <div
      className={cn(
        'bg-white border rounded-lg p-4 transition-shadow hover:shadow-sm',
        state === 'default' && 'border-ducens-border',
        state === 'success' && 'border-ducens-success/40 bg-green-50',
        state === 'warn' && 'border-ducens-warn/40 bg-orange-50',
        state === 'danger' && 'border-ducens-danger/40 bg-red-50'
      )}
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs uppercase tracking-wide text-ducens-muted font-medium">{label}</span>
        {Icon && <Icon className="w-4 h-4 text-ducens-muted" />}
      </div>
      <div className="flex items-baseline gap-1.5">
        <div className="text-2xl font-semibold tabular-nums">{value}</div>
        {unit && <div className="text-sm text-ducens-muted">{unit}</div>}
      </div>
      {variation !== undefined && (
        <div
          className={cn(
            'flex items-center gap-1 text-xs mt-1.5',
            variation > 0 && 'text-ducens-success',
            variation < 0 && 'text-ducens-danger',
            variation === 0 && 'text-ducens-muted'
          )}
        >
          {variation > 0 && <ArrowUp className="w-3 h-3" />}
          {variation < 0 && <ArrowDown className="w-3 h-3" />}
          {variation === 0 && <Minus className="w-3 h-3" />}
          <span>{variation > 0 ? '+' : ''}{variation.toFixed(1)}{unit?.includes('%') ? 'pp' : '%'} vs hier</span>
        </div>
      )}
      {helper && <div className="text-xs text-ducens-muted mt-2">{helper}</div>}
    </div>
  );
}
